import { createApiClient } from "Network/ApiClient";

export const PrincipalDiagnosedAxiosInstance = createApiClient(
  "PrincipalDiagnosed/",
);
